import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { CronEditorModule } from '@cron-builder';
import { DomainModule } from '@domain';
import { MaterialModule } from '@material';
import { TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { SharedModule } from '@shared';
import { StoreModule } from '@store';
import { TranslationModule } from '@translation';
import { AngularEditorModule } from 'angular-editor';
import { BroadcasterModule } from 'ng-broadcaster';
import { NgQueryBuilderModule } from 'ng-query-builder';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import {
    LucideAngularModule,
    Settings,
    ChevronDown,
    ChevronLeft,
    LayoutGrid,
    Building2,
    TableProperties,
    Database,
    Table,
    Grid,
    EllipsisVertical,
    History,
} from 'lucide-angular';

import { AddConfigurationModalComponent } from './components/addconfigurationmodal/addconfigurationmodal.component';
import { AddRecordsComponent } from './components/addrecords/addrecords.component';
import { AggregationsMenu } from './components/aggregations-menu/aggregations-menu.component';
import { AppCollaborationComponent } from './components/app-collaboration/app-collab.component';
import { AppDisplayNameComponent } from './components/app-display-name/app-display-name.component';
import { AssetlookupComponent } from './components/assetlookup/assetlookup.component';
import { AttachmentFileViewComponent } from './components/attachment-file-view/attachment-file-view.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { ChangePasswordComponent } from './components/changepassword/changepassword.component';
import { ChartDataComponent } from './components/chart-data/chart-data.component';
import { CodeEditorComponent } from './components/code-editor/code-editor.component';
import { ColumnMatchingDialogComponent } from './components/column-matching-dialog/column-matching-dialog.component';
import { EntitySearchFilter } from './components/common-entity-search-filter/entity-search-filter.component';
import { CommonMastersComponent } from './components/common-masters/common-masters.component';
import { CommonNotificationsEventlogsComponent } from './components/common-notifications-eventlogs/common-notifications-eventlogs.component';
import { CommonNotificationsComponent } from './components/common-notifications/common-notifications.component';
import { CommonSearchCriteriaViewComponent } from './components/common-search-criteria-view/common-search-criteria-view.component';
import { CommonTemplatesComponent } from './components/common-templates/common-templates.component';
import { CommonchangelogrecordComponent } from './components/commonchangelogrecord/commonchangelogrecord.component';
import { CommoncollaborationlistComponent } from './components/commoncollaborationlist/commoncollaborationlist.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { ConnectorComponent } from './components/connector/connector.component';
import { ConnectorsComponent } from './components/connectors/connectors.component';
import { ConsolidateComponent } from './components/consolidate/consolidate.component';
import { CustomSearchComponent } from './components/custom-search/custom-search.component';
import { DateFilterComponent } from './components/date-filter/date-filter.component';
import { DigitalSignatureComponent } from './components/digital-signature/digital-signature.component';
import { DocPreviewComponent } from './components/doc-preview/doc-preview.component';
import { DotsLoaderComponent } from './components/dotsloader/dotsloader.component';
import { DowntimeActiveMessageComponent } from './components/downtime-active-message/downtime-active-message';
import { DurationComponent } from './components/duration/duration.component';
import { EditAuthorizationSystemComponent } from './components/edit-authorization-system/edit-authorization-system.component';
import { EditprofileComponent } from './components/editprofile/editprofile.component';
import { ElasticQueryBuilderComponent } from './components/elasticquerybuilder/elasticquerybuilder.component';
import { EntitiesTemplateComponent } from './components/entities-template/entities-template.component';
import { EntityRecordFieldAttachmentComponent } from './components/entity-record-field-attachment/entity-record-field-attachment.component';
import { EntityRecordFieldGridTableComponent } from './components/entity-record-field-grid-table/entity-record-field-grid-table.component';
import { EntityRecordFieldGridComponent } from './components/entity-record-field-grid/entity-record-field-grid.component';
import { EntityRecordFieldTemplateComponent } from './components/entity-record-field-template/entity-record-field-template.component';
import { EntityRecordTemplateComponent } from './components/entity-record-template/entity-record-template.component';
import { EntityRecordsDisplayComponent } from './components/entity-records-display/entity-records-display.component';
import { EntitySearchComponent } from './components/entity-search/entity-search.component';
import { EntityTemplateComponent } from './components/entity-template/entity-template.component';
import { EventsSubscriptionAdvancedEditComponent } from './components/events-subscription-advanced-edit/events-subscription-advanced-edit.component';
import { FetchAssetsModalComponent } from './components/fetch-assets-modal/fetch-assets-modal.component';
import { FieldInputTemplateComponent } from './components/field-input-template/field-input-template.component';
import { FieldLevelFileAttachmentComponent } from './components/field-level-file-attachment/field-level-file-attachment.component';
import { FilingAttributeFieldComponent } from './components/filingattributefield/filingattributefield.component';
import { GrammarRendererModalComponent } from './components/grammar-renderer-modal/grammar-renderer-modal.component';
import { GrammarRendererComponent } from './components/grammar-renderer/grammar-renderer.component';
import { GridFieldModalComponent } from './components/grid-field-modal/grid-field-modal.component';
import { GridFieldComponent } from './components/grid-field/grid-field.component';
import { HeaderShortcutsComponent } from './components/header-shortcuts/header-shortcuts.component';
import { HelpDocPreviewComponent } from './components/help-doc-preview/help-doc-preview.component';
import { HelpDocumentViewComponent } from './components/help-document-view/help-document-view.component';
import { HomeAppMatContainerComponent } from './components/home-app-mat-container/home-app-mat-container.component';
import { HomeAppProcessComponent } from './components/home-app-process/home-app-process.component';
import { HomeBridgeProcessComponent } from './components/home-bridge-process/home-bridge-process.component';
import { HomeProcessesComponent } from './components/home-processes/home-processes.component';
import { IconsComponent } from './components/icons/icons.component';
import { MaterialInputAutoCompleteComponent } from './components/inputautocomplete/inputautocomplete.component';
import { InstanceDataDialogComponent } from './components/instance-data-dialog/instance-data-dialog.component';
import { InstanceDataEntitiesComponent } from './components/instance-data-entities/instance-data-entities.component';
import { InstanceDataPrimaryEntityComponent } from './components/instance-data-primary-entity/instance-data-primary-entity.component';
import { InstanceDataTableComponent } from './components/instance-data-table/instance-data-table.component';
import { InstanceReconcileDataDialogComponent } from './components/instance-reconcile-data-dialog/instance-reconcile-data-dialog.component';
import { IntegrationPostmanTabStuctureComponent } from './components/integration-postman-tab-stucture/integration-postman-tab-stucture.component';
import { IntegrationSubSectionsComponent } from './components/integration-sub-sections/integration-sub-sections.component';
import { IntegrationTableStuctureComponent } from './components/integration-table-structure/integration-table-stucture.component';
import { IntegrationFieldsComponent } from './components/integrationfields/integrationfields.component';
import { IntegrationsFieldTemplateComponent } from './components/integrations-field-template/integrations-field-template.component';
import { IntegrationsPostmanStructureComponent } from './components/integrations-postman-structure/integrations-postman-structure.component';
import { IntegrationsTemplateComponent } from './components/integrations-template/integrations-template.component';
import { LandingPagePreferenceComponent } from './components/landing-page-preference/landing-page-preference.component';
import { LeftNavAppsTemplateComponent } from './components/left-nav-apps-template/left-nav-apps-template.component';
import { MasterChangeLogComponent } from './components/masterchangelogs/masterchangelog.component';
import { MasterlookupComponent } from './components/masterlookup/masterlookup.component';
import { MasterlookupinputComponent } from './components/masterlookupinput/masterlookupinput.component';
import { MasterRequestsNotificationsComponent } from './components/masterrequests/masterrequests.component';
import { MastersearchComponent } from './components/mastersearch/mastersearch.component';
import { MaterialCardComponent } from './components/material/card/card.component';
import { MaterialGroupCheckboxComponent } from './components/material/material-group-checkbox/material-group-checkbox.component';
import { MaterialTableComponent } from './components/material/table/table.component';
import { VirtualTableComponent } from './components/material/virtual-table/virtual-table.component';
import { MessagePopupComponent } from './components/messagepopup/messagepopup.component';
import { MultipleRecordEditComponent } from './components/multiple-record-edit/multiple-record-edit.component';
import { NewProcessComponent } from './components/new-process/new-process.component';
import { NewReconciliationProcessComponent } from './components/new-reconciliation-process/new-reconciliation-process.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { ProcessLogComponent } from './components/process-log/process-log.component';
import { QueryBuilderNewComponent } from './components/query-builder-new/query-builder-new.component';
import { QuerybuilderComponent } from './components/query-builder/querybuilder.component';
import { RecordFieldsComponent } from './components/recordfields/recordfields.component';
import { ReportIconComponent } from './components/report-icon/report-icon.component';
import { ReportsViewComponent } from './components/reports-view/reports-view.component';
import { RichTextEditorComponent } from './components/rich-text-editor/rich-text-editor.component';
import { SavecustomfilterComponent } from './components/savecustomfilter/savecustomfilter.component';
import { SaveReconTemplateComponent } from './components/saverecontemplate/save-recon-template.component';
import { SearchBuilderComponent } from './components/search-builder/search-builder.component';
import { SearchModalComponent } from './components/search-modal/search-modal.component';
import { SessionCheckComponent } from './components/session-check/session-check.component';
import { SessionExpiredModalComponent } from './components/session-expired-modal/session-expired-modal.component';
import { SettingsNestedMenuComponent } from './components/settings-nested-menu/settings-nested-menu.component';
import { SourceTableComponent } from './components/sourcetable/sourcetable.component';
import { TableInputComponent } from './components/table-input/table-input.component';
import { TaxillaHeaderComponent } from './components/taxilla-header/taxilla-header.component';
import { TemplateListTableComponent } from './components/template-list-table/template-list-table.component';
import { TimeFiltersComponent } from './components/time-filters/time-filters.component';
import { ToleranceDetailsDialogComponent } from './components/tolerance-details-dialog/tolerance-details-dialog.component';
import { UpdateRequestComponent } from './components/updateRequestModal/updaterequest.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { UserPreferencesDialogComponent } from './components/user-preferences-dialog/user-preferences-dialog.component';
import { ViewOrCloneConnectorComponent } from './components/view-or-clone-connector/view-or-clone-connector.component';
import { WorkflowFieldsInputComponent } from './components/workflow-fields-input/workflow-fields-input.component';
import { AllProcessActionDialogComponent } from './dialogs/all-process-action-dialog/all-process-action-dialog.component';
import { AssociateBulkDialogComponent } from './dialogs/associate-bulk-dialog/associate-bulk-dialog.component';
import { AuditChangeLogsDialogComponent } from './dialogs/audit-change-logs-dialog/audit-change-logs-dialog.component';
import { BulkDeleteActionDialog } from './dialogs/bulk-delete-action-dialog/bulkdeleteactiondialog.component';
import { CollaboratorsDialogComponent } from './dialogs/collaborations-dialog/collaborators-dialog.component';
import { CollaborationlistDialog } from './dialogs/collabrationlist-dialog/collaborationlist.component';
import { DownloadBulkReportsDialogComponent } from './dialogs/download-bulk-reports-dialog/download-bulk-reports-dialog.component';
import { DownloadFilesDialogComponent } from './dialogs/download-files-dialog/download-files-dialog.component';
import { IntegrationStatusDialogComponent } from './dialogs/integration-status-dialog/integration-status-dialog.component';
import { NotificationsDialogComponent } from './dialogs/notifications-dialog/notifications-dialog.component';
import { PreCapturedAttributesDialogComponent } from './dialogs/pre-captured-attributes-dialog/pre-captured-attributes-dialog.component';
import { ProcessLogdailogComponent } from './dialogs/process-logdailog/process-logdailog.component';
import { ReportsDialogComponent } from './dialogs/reports-dialog/reports-dialog.component';
import { UploadFilesDialogComponent } from './dialogs/upload-files-dialog/upload-files-dialog.component';
import { AppDataDirective } from './directives/app-data/app-data.directive';
import { AppDetectOutsideClickDirective } from './directives/app-detect-outside/app-detect-outside-click.directive';
import { AppNewProcessDirective } from './directives/app-new-process/app-new-process.directive';
import { AppProcessRequestDirective } from './directives/app-process-request/app-process-request.directive';
import { AppProcessesSelectionDirective } from './directives/app-processes/app-processes.directive';
import { AppSelectionDirective } from './directives/app-selection/app-selection.directive';
import { BacktopreviousDirective } from './directives/backtoprevious.directive';
import { DebounceDirective } from './directives/debounce';
import { DisableClipboardDirective } from './directives/disable-clipboard/disable-clipboard.directive';
import { EventPropagationDirective } from './directives/eventpropagation/eventpropagation.directive';
import { HubStorageDirective } from './directives/hub-storage/hubstorage.directive';
import { ResponseInterceptor } from './interceptors/responseinterceptor';
import { TokenInterceptor } from './interceptors/token/tokeninterceptor';
import { AlphabeticalOrderPipe } from './pipes/alphabetical-order/alphabetical-order.pipe';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { DecodeTextFieldPipe } from './pipes/decode-text-field.pipe';
import { FieldsGroupPipe } from './pipes/fields-group.pipe';
import { HighlightPipe } from './pipes/highlight.pipe';
import { MultiFilterPipe } from './pipes/multi-filter.pipe';
import { ObjNgFor } from './pipes/objectTransform.pipe';
import { OrderByPipe } from './pipes/order-by/order-by.pipe';
import { PrimaryHeaderRecordFieldsPipe } from './pipes/primary-header-record-fields.pipe';
import { PrimarySubHeaderRecordFieldsPipe } from './pipes/primary-subheader-record-fields.pipe';
import { RemoveAriaOwnsDirective } from './pipes/remove-aria-owns.pipe';
import { ReportsFilterPipe } from './pipes/reports-filter.pipe';
import { SortassetsPipe } from './pipes/sortassets.pipe';
import { NewProcessService } from './services/new-process/new-process.service';
import { UtilsService } from './services/utils/utils.service';

const materialModules = [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatStepperModule,
    MatDatepickerModule,
    MatPaginatorModule,
    MatNativeDateModule,
    MatListModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatChipsModule,
    MatGridListModule,
    MatProgressBarModule,
    MatRippleModule,
    MatSidenavModule,
    MatSliderModule,
    MatTreeModule,
    MatFormFieldModule,
    A11yModule,
    DragDropModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    ScrollingModule,
    DragDropModule,
];

const angularModules = [CommonModule, RouterModule, FormsModule, ReactiveFormsModule];

const necessaryModules = [PerfectScrollbarModule, NgxMaterialTimepickerModule, NgQueryBuilderModule, TranslationModule, CronEditorModule];

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
};

@NgModule({
    imports: [
        StoreModule,
        SharedModule,
        DomainModule,
        MaterialModule,
        TranslationModule,
        HttpClientModule,
        CommonModule,
        MatMenuModule,
        RouterModule,
        ...angularModules,
        ...materialModules,
        ...necessaryModules,
        BroadcasterModule,
        AngularEditorModule,
        LucideAngularModule.pick({
            Settings,
            ChevronDown,
            ChevronLeft,
            LayoutGrid,
            Building2,
            TableProperties,
            Database,
            Table,
            Grid,
            EllipsisVertical,
            History,
        }),
    ],
    declarations: [
        TaxillaHeaderComponent,
        EntitySearchFilter,
        AggregationsMenu,
        SessionCheckComponent,
        AlphabeticalOrderPipe,
        HighlightPipe,
        CapitalizePipe,
        DecodeTextFieldPipe,
        FieldsGroupPipe,
        RemoveAriaOwnsDirective,
        ReportsFilterPipe,
        PrimaryHeaderRecordFieldsPipe,
        PrimarySubHeaderRecordFieldsPipe,
        HubStorageDirective,
        AppSelectionDirective,
        AppProcessesSelectionDirective,
        AppNewProcessDirective,
        AppProcessRequestDirective,
        AppDataDirective,
        AppDetectOutsideClickDirective,
        OrderByPipe,
        SessionExpiredModalComponent,
        MaterialCardComponent,
        ObjNgFor,
        HomeProcessesComponent,
        HomeBridgeProcessComponent,
        HomeAppProcessComponent,
        HomeAppMatContainerComponent,
        MaterialInputAutoCompleteComponent,
        NewProcessComponent,
        MaterialGroupCheckboxComponent,
        DebounceDirective,
        TableInputComponent,
        FilingAttributeFieldComponent,
        AssetlookupComponent,
        SourceTableComponent,
        UpdateRequestComponent,
        FieldInputTemplateComponent,
        GridFieldComponent,
        FieldLevelFileAttachmentComponent,
        MasterlookupComponent,
        MasterlookupinputComponent,
        EventPropagationDirective,
        EditprofileComponent,
        ChangePasswordComponent,
        UserPreferencesDialogComponent,
        LandingPagePreferenceComponent,
        ConfirmationComponent,
        ReportsViewComponent,
        ReportIconComponent,
        IconsComponent,
        CommonNotificationsComponent,
        CommonTemplatesComponent,
        GridFieldModalComponent,
        RichTextEditorComponent,
        DateFilterComponent,
        DowntimeActiveMessageComponent,
        DurationComponent,
        CommoncollaborationlistComponent,
        SettingsNestedMenuComponent,
        RecordFieldsComponent,
        AttachmentFileViewComponent,
        MultipleRecordEditComponent,
        HeaderShortcutsComponent,
        CommonMastersComponent,
        GrammarRendererComponent,
        GrammarRendererModalComponent,
        IntegrationsFieldTemplateComponent,
        IntegrationsTemplateComponent,
        AddConfigurationModalComponent,
        CollaborationlistDialog,
        BulkDeleteActionDialog,
        AllProcessActionDialogComponent,
        PreCapturedAttributesDialogComponent,
        ReportsDialogComponent,
        UploadFilesDialogComponent,
        DownloadBulkReportsDialogComponent,
        AssociateBulkDialogComponent,
        DownloadFilesDialogComponent,
        CollaboratorsDialogComponent,
        NotificationsDialogComponent,
        AuditChangeLogsDialogComponent,
        IntegrationStatusDialogComponent,
        ProcessLogdailogComponent,
        IntegrationsPostmanStructureComponent,
        MastersearchComponent,
        SavecustomfilterComponent,
        SaveReconTemplateComponent,
        TemplateListTableComponent,
        ElasticQueryBuilderComponent,
        MasterRequestsNotificationsComponent,
        CommonchangelogrecordComponent,
        CommonNotificationsEventlogsComponent,
        CommonSearchCriteriaViewComponent,
        IntegrationFieldsComponent,
        MasterChangeLogComponent,
        AppCollaborationComponent,
        AddRecordsComponent,
        EntitiesTemplateComponent,
        EntityTemplateComponent,
        EntityRecordTemplateComponent,
        ChartDataComponent,
        EntitySearchComponent,
        SearchBuilderComponent,
        QuerybuilderComponent,
        QueryBuilderNewComponent,
        DotsLoaderComponent,
        SortassetsPipe,
        MultiFilterPipe,
        ConsolidateComponent,
        NewReconciliationProcessComponent,
        CustomSearchComponent,
        NotificationsComponent,
        MessagePopupComponent,
        TimeFiltersComponent,
        BacktopreviousDirective,
        WorkflowFieldsInputComponent,
        DigitalSignatureComponent,
        DocPreviewComponent,
        UserDetailsComponent,
        AppDisplayNameComponent,
        ProcessLogComponent,
        EntityRecordFieldTemplateComponent,
        EntityRecordFieldAttachmentComponent,
        EntityRecordFieldGridComponent,
        EntityRecordFieldGridTableComponent,
        SearchModalComponent,
        CategoriesComponent,
        LeftNavAppsTemplateComponent,
        FetchAssetsModalComponent,
        HelpDocumentViewComponent,
        EventsSubscriptionAdvancedEditComponent,
        FieldInputTemplateComponent,
        DisableClipboardDirective,
        HelpDocPreviewComponent,
        InstanceDataPrimaryEntityComponent,
        InstanceDataEntitiesComponent,
        InstanceDataTableComponent,
        InstanceDataDialogComponent,
        InstanceReconcileDataDialogComponent,
        ColumnMatchingDialogComponent,
        ToleranceDetailsDialogComponent,
        ConnectorComponent,
        ConnectorsComponent,
        ViewOrCloneConnectorComponent,
        IntegrationPostmanTabStuctureComponent,
        GrammarRendererComponent,
        GrammarRendererModalComponent,
        IntegrationSubSectionsComponent,
        IntegrationTableStuctureComponent,
        CodeEditorComponent,
        EditAuthorizationSystemComponent,
        MaterialTableComponent,
        VirtualTableComponent,
        EntityRecordsDisplayComponent,
    ],
    exports: [
        StoreModule,
        SharedModule,
        DomainModule,
        MaterialModule,
        TranslationModule,
        TaxillaHeaderComponent,
        SessionCheckComponent,
        EntitySearchFilter,
        MatMenuModule,
        AggregationsMenu,
        HubStorageDirective,
        AppSelectionDirective,
        AppProcessesSelectionDirective,
        AppNewProcessDirective,
        DocPreviewComponent,
        AppProcessRequestDirective,
        AppDetectOutsideClickDirective,
        HomeProcessesComponent,
        HomeAppProcessComponent,
        NewProcessComponent,
        ReportsViewComponent,
        ReportIconComponent,
        IconsComponent,
        DateFilterComponent,
        MaterialGroupCheckboxComponent,
        MaterialCardComponent,
        EventPropagationDirective,
        FieldsGroupPipe,
        CommonNotificationsComponent,
        CommonTemplatesComponent,
        GridFieldComponent,
        TableInputComponent,
        GridFieldModalComponent,
        RichTextEditorComponent,
        CodeEditorComponent,
        ChangePasswordComponent,
        UserPreferencesDialogComponent,
        LandingPagePreferenceComponent,
        PerfectScrollbarModule,
        DowntimeActiveMessageComponent,
        DurationComponent,
        ...angularModules,
        ...materialModules,
        ...necessaryModules,
        LucideAngularModule,
        DebounceDirective,
        CommoncollaborationlistComponent,
        SettingsNestedMenuComponent,
        RecordFieldsComponent,
        AttachmentFileViewComponent,
        MultipleRecordEditComponent,
        HeaderShortcutsComponent,
        SourceTableComponent,
        AllProcessActionDialogComponent,
        NotificationsDialogComponent,
        AuditChangeLogsDialogComponent,
        UploadFilesDialogComponent,
        DownloadBulkReportsDialogComponent,
        AssociateBulkDialogComponent,
        DownloadFilesDialogComponent,
        CollaboratorsDialogComponent,
        PreCapturedAttributesDialogComponent,
        ReportsDialogComponent,
        IntegrationStatusDialogComponent,
        IntegrationsFieldTemplateComponent,
        IntegrationsTemplateComponent,
        ProcessLogdailogComponent,
        GrammarRendererComponent,
        GrammarRendererModalComponent,
        AddConfigurationModalComponent,
        CollaborationlistDialog,
        BulkDeleteActionDialog,
        IntegrationsPostmanStructureComponent,
        CommonMastersComponent,
        MastersearchComponent,
        SavecustomfilterComponent,
        SaveReconTemplateComponent,
        TemplateListTableComponent,
        ElasticQueryBuilderComponent,
        MasterRequestsNotificationsComponent,
        CommonchangelogrecordComponent,
        CommonNotificationsEventlogsComponent,
        CommonSearchCriteriaViewComponent,
        IntegrationFieldsComponent,
        MasterChangeLogComponent,
        AppCollaborationComponent,
        AddRecordsComponent,
        ChartDataComponent,
        EntitySearchComponent,
        SearchBuilderComponent,
        QuerybuilderComponent,
        QueryBuilderNewComponent,
        DotsLoaderComponent,
        FilingAttributeFieldComponent,
        FieldLevelFileAttachmentComponent,
        SortassetsPipe,
        MultiFilterPipe,
        ConsolidateComponent,
        NewReconciliationProcessComponent,
        CustomSearchComponent,
        NotificationsComponent,
        MessagePopupComponent,
        TimeFiltersComponent,
        BacktopreviousDirective,
        ReportsFilterPipe,
        AlphabeticalOrderPipe,
        HighlightPipe,
        CapitalizePipe,
        DecodeTextFieldPipe,
        RemoveAriaOwnsDirective,
        OrderByPipe,
        PrimaryHeaderRecordFieldsPipe,
        PrimarySubHeaderRecordFieldsPipe,
        ObjNgFor,
        WorkflowFieldsInputComponent,
        UserDetailsComponent,
        ProcessLogComponent,
        SearchModalComponent,
        CategoriesComponent,
        LeftNavAppsTemplateComponent,
        FetchAssetsModalComponent,
        HelpDocumentViewComponent,
        EventsSubscriptionAdvancedEditComponent,
        FieldInputTemplateComponent,
        DisableClipboardDirective,
        HelpDocPreviewComponent,
        InstanceDataPrimaryEntityComponent,
        InstanceDataEntitiesComponent,
        InstanceDataTableComponent,
        InstanceDataDialogComponent,
        InstanceReconcileDataDialogComponent,
        ColumnMatchingDialogComponent,
        ConnectorComponent,
        ConnectorsComponent,
        ViewOrCloneConnectorComponent,
        EditAuthorizationSystemComponent,
        MaterialTableComponent,
        VirtualTableComponent,
        EntityRecordsDisplayComponent,
    ],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ResponseInterceptor,
            multi: true,
        },
        {
            provide: TRANSLOCO_SCOPE,
            useValue: '',
        },
        NewProcessService,
        UtilsService,
    ],
})
export class TaxillaLibraryModule {
    constructor() {
        if (
            typeof window !== 'undefined' &&
            typeof MutationObserver !== 'undefined' &&
            !(window as any).__ngxTimepickerPopoverObserverInit
        ) {
            (window as any).__ngxTimepickerPopoverObserverInit = true;
            const initObserver = () => {
                if (!document.body) return;
                const observer = new MutationObserver(mutations => {
                    for (const mutation of mutations) {
                        for (const node of Array.from(mutation.addedNodes)) {
                            if (node.nodeType === 1) {
                                const el = node as HTMLElement;
                                const container =
                                    el.tagName === 'NGX-MATERIAL-TIMEPICKER-CONTAINER'
                                        ? el
                                        : el.querySelector?.('ngx-material-timepicker-container');
                                if (container && typeof (container as any).showPopover === 'function') {
                                    try {
                                        container.setAttribute('popover', 'manual');
                                        (container as any).showPopover();
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }
                            }
                        }
                    }
                });
                observer.observe(document.body, { childList: true, subtree: true });
            };
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', initObserver);
            } else {
                initObserver();
            }
        }
    }
}
